let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ib3UG")).then(() => parcelRequire('8RsTW'));